import { render, staticRenderFns } from "./quotes-block.vue?vue&type=template&id=8e2e457e&scoped=true"
var script = {}
import style0 from "./quotes-block.vue?vue&type=style&index=0&id=8e2e457e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2e457e",
  null
  
)

export default component.exports